import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ErrorBoundary } from "react-error-boundary";

import { SidebarProvider } from "@/components/ui/sidebar/sidebar";
import { CheckRoleProvider } from "@/features/admin/_providers/check-role-provider";
import { CreateCustomerDialog } from "@/features/admin/customers/create";
import {
  IMPERSONATE_DIALOG_ACTION,
  ImpersonateDialog,
  ImpersonationFrame,
} from "@/features/admin/impersonation";
import { AppSidebar } from "@/features/admin/sidebar";
import { ProtectedProvider } from "@/features/auth/_providers/protected-provider";
import { ErrorFallback } from "@/features/shared/error-fallback";
import { GlobalBirdieChat } from "@/features/shared/global-birdie-chat";
import { BirdieAwareSidebarInset } from "@/features/shared/global-birdie-chat/_components/birdie-aware-sidebar-inset";
import { PageContextRoot } from "@/features/shared/page-context";
import { StatsigProvider } from "@/features/shared/providers/statsig-provider";
import { TeamAnalyticsProvider } from "@/features/shared/providers/team-analytics-provider";
import {
  TeamRealtimeProvider,
  UserRealtimeProvider,
} from "@/features/shared/realtime-refresh";
import { useQueryState } from "@/hooks/use-query-state";

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
});

function AdminLayout() {
  const [action] = useQueryState("action");

  return (
    <ProtectedProvider>
      <TeamAnalyticsProvider>
        <CheckRoleProvider>
          <TeamRealtimeProvider>
            <UserRealtimeProvider>
              <PageContextRoot>
                <StatsigProvider>
                  <SidebarProvider>
                    <AppSidebar />
                    <ErrorBoundary
                      fallbackRender={({ error }) => (
                        <ErrorFallback error={error} />
                      )}
                    >
                      <BirdieAwareSidebarInset>
                        <Outlet />
                      </BirdieAwareSidebarInset>
                    </ErrorBoundary>
                    {/* Global Dialog */}
                    {action === "create-customer" && <CreateCustomerDialog />}
                    {action === IMPERSONATE_DIALOG_ACTION && (
                      <ImpersonateDialog />
                    )}
                    <ImpersonationFrame />
                    <GlobalBirdieChat />
                    {/* End Global Dialog */}
                  </SidebarProvider>
                </StatsigProvider>
              </PageContextRoot>
            </UserRealtimeProvider>
          </TeamRealtimeProvider>
        </CheckRoleProvider>
      </TeamAnalyticsProvider>
    </ProtectedProvider>
  );
}
